<table class="{{colorScheme.main}}" *ngIf="statistic?.stats" [class.krone-layout]="layout === 'krone'">
  <tr>
    <th>#</th>
    <th></th>
    <th class="column-left">Spieler</th>
    <th></th>
    <th *ngIf="type === types.Scorers">Score</th>
    <th *ngIf="type === types.Goals">Tore</th>
    <th *ngIf="type === types.Assists">Assists</th>
  </tr>
  <tr *ngFor="let player of statistic.stats" (click)="onScorerClick(player.team_info?.readable_id)">
    <td>
      {{player.pos}}
      <a *ngIf="player.team_info?.readable_id" [href]="getLink(player.team_info.readable_id)"></a>
    </td>
    <td>
      <img *ngIf="player.emblemUrl" alt="Team Logo" [src]="player.emblemUrl">
    </td>
    <td class="column-left player" *ngIf="!player.playername">
      <span>{{player.firstname}} <strong class="player-name">{{player.lastname}}</strong></span>
      <span *ngIf="player.team_info?.name" class="team-name">{{player.team_info.name}}</span>
    </td>
    <td class="column-left" *ngIf="player.playername">
      <span class="player-name">{{player.playername}}</span>
      <span *ngIf="player.team_info?.name" class="team-name">{{player.team_info.name}}</span>
    </td>
    <td>
      <img *ngIf="player.team_info?.emblem_url" alt="Team Logo" [src]="player.team_info.emblem_url">
    </td>
    <td *ngIf="type === types.Scorers">{{player.scorer_points}}</td>
    <td *ngIf="type === types.Goals">{{player.goals}}</td>
    <td *ngIf="type === types.Assists">{{player.assists}}</td>
  </tr>
</table>
